const rankOrder = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
const combos = {
    'exit-liquidity': { comboId: 'exit-liquidity', name: 'Exit Liquidity', score: 30, multiplier: 1 },
    'twin-rugs': { comboId: 'twin-rugs', name: 'Twin Rugs', score: 50, multiplier: 1.5 },
    'double-bottom': { comboId: 'double-bottom', name: 'Double Bottom', score: 70, multiplier: 1.6 },
    'triple-top': { comboId: 'triple-top', name: 'Triple Top', score: 90, multiplier: 2.4 },
    'bull-run': { comboId: 'bull-run', name: 'Bull Run', score: 100, multiplier: 2.7 },
    'chain-maxi': { comboId: 'chain-maxi', name: 'Chain Maxi', score: 110, multiplier: 3 },
    'vc-full-bag': {
        comboId: 'vc-full-bag',
        name: 'VC Full Bag',
        score: 120,
        multiplier: 3.2,
    },
    'sybil-attack': {
        comboId: 'sybil-attack',
        name: 'Sybil Attack',
        score: 140,
        multiplier: 3.6,
    },
    'the-singularity': {
        comboId: 'the-singularity',
        name: 'The Singularity',
        score: 160,
        multiplier: 4,
    },
};
export const HAND_COMBO_METADATA = Object.values(combos).sort((a, b) => a.multiplier - b.multiplier);
const sortRanks = (cards) => cards
    .map((card) => card.rank)
    .slice()
    .sort((a, b) => rankOrder.indexOf(a) - rankOrder.indexOf(b));
const isSequential = (ranks) => {
    const indexes = ranks.map((rank) => rankOrder.indexOf(rank));
    for (let i = 1; i < indexes.length; i += 1) {
        if (indexes[i] - indexes[i - 1] !== 1) {
            return false;
        }
    }
    return true;
};
export const resolveCombo = (cards) => {
    if (cards.length === 0) {
        return combos['exit-liquidity'];
    }
    const rankCounts = cards.reduce((acc, card) => {
        acc[card.rank] = (acc[card.rank] ?? 0) + 1;
        return acc;
    }, {});
    const counts = Object.values(rankCounts).sort((a, b) => b - a);
    const pairs = counts.filter((count) => count === 2).length;
    const hasThree = counts.includes(3);
    const mostOfAKind = counts[0];
    const distinctRanks = Object.keys(rankCounts).length;
    const suits = new Set(cards.map((card) => card.suit));
    const sortedRanks = sortRanks(cards);
    const isFlush = cards.length >= 5 && suits.size === 1;
    const isStraight = cards.length >= 5 && distinctRanks === cards.length && isSequential(sortedRanks);
    const isStraightFlush = isStraight && isFlush;
    const isFourOfKind = mostOfAKind >= 4;
    const isFullHouse = cards.length >= 5 && hasThree && pairs >= 1;
    const isThreeOfKind = hasThree;
    const isTwoPair = pairs >= 2;
    const isPair = counts.includes(2);
    if (isStraightFlush) {
        return combos['the-singularity'];
    }
    if (isFourOfKind) {
        return combos['sybil-attack'];
    }
    if (isFullHouse) {
        return combos['vc-full-bag'];
    }
    if (isFlush) {
        return combos['chain-maxi'];
    }
    if (isStraight) {
        return combos['bull-run'];
    }
    if (isThreeOfKind) {
        return combos['triple-top'];
    }
    if (isTwoPair) {
        return combos['double-bottom'];
    }
    if (isPair) {
        return combos['twin-rugs'];
    }
    return combos['exit-liquidity'];
};
export const calculateScore = (cards, modifiers = []) => {
    const combo = resolveCombo(cards);
    const modifierBonus = modifiers.reduce((total, current) => total + current.bonus, 0);
    const total = Math.round((combo.score + modifierBonus) * combo.multiplier);
    return {
        total,
        combo,
        modifiers: modifiers.map((modifier) => ({
            name: modifier.name,
            bonus: modifier.bonus,
        })),
    };
};
export const evaluateHands = (hands, modifiers = []) => {
    return hands.map((hand, index) => ({
        cards: hand,
        breakdown: calculateScore(hand, modifiers[index] ?? []),
    }));
};
//# sourceMappingURL=scoring.js.map